import React from 'react';
import { Box, CircularProgress, IconButton, Theme } from '@mui/material';
import PlayArrow from '@mui/icons-material/PlayArrow';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { useCoverStyles } from '../../lib/hook/useCoverStyles';
import { useLazyImage } from '../../lib/hook/useLazyImage';

const useStyles = makeStyles((theme: Theme) => ({
  blackbox: {
    backgroundColor: 'black',
  },
  box: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
    '&:hover $description': {
      display: 'flex',
    },
  },
  description: {
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.8)',
    bottom: 0,
    color: 'white',
    display: 'none',
    fontSize: theme.typography.body2.fontSize,
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 999,
  },
  playButton: {
    backgroundColor: 'var(--cover-editor-remove-custom-background)',
    border: '1px solid var(--border-play-button)',
    color: 'white',
    padding: theme.spacing(2.375),
    '&:hover': {
      backgroundColor: 'var(--cover-editor-remove-custom-background)',
    },
  },
}));

interface IProps {
  className?: string;
  classNamePlayButton?: string;
  clickable?: boolean;
  cover?: string;
  description?: string;
  loading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  playButton?: boolean;
  visible?: boolean;
}

const ContentCover: React.FC<IProps> = ({
  className,
  classNamePlayButton,
  clickable = false,
  cover,
  description,
  loading = false,
  onClick,
  playButton = false,
  visible = true,
}) => {
  const classes = useStyles();
  const coverClasses = useCoverStyles();

  const lazyCover = useLazyImage(cover, visible);

  return (
    <Box
      className={classNames(
        coverClasses.root,
        classes.box,
        {
          [classes.blackbox]: !lazyCover,
        },
        className
      )}
      onClick={onClick}
      style={{
        backgroundImage: lazyCover ? `url("${lazyCover}")` : 'none',
        backgroundColor: lazyCover ? 'none' : 'var(--cover-background-color)',
        cursor: clickable ? 'pointer' : 'auto',
      }}
    >
      {description && <Box className={classes.description}>{description}</Box>}
      {loading && <CircularProgress color="secondary" />}
      {playButton && (
        <IconButton
          classes={{
            root: classNames(classes.playButton, classNamePlayButton),
          }}
          size="large"
        >
          <PlayArrow />
        </IconButton>
      )}
    </Box>
  );
};

export default ContentCover;
